import React from 'react';
import HomieContext from 'HomieContext';
import TenantReport from './TenantReport';

const TenantReportWithContext = () => {
  return (
    <HomieContext.Consumer>
      {value => (
        <TenantReport
          showProcessLoading={value.showLoadingProcessView}
          hideProcessLoading={value.hideLoadingProcessView}
        />
      )}
    </HomieContext.Consumer>
  );
};

export default TenantReportWithContext;
